import * as React from 'react';
import styled from "styled-components";

const SPhrase = styled.div`
  flex: 1;
  padding: 5px 20px;
  td {
    padding: 5px;
  }
`;

const Phrase = () => {
  return (
    <SPhrase>
      <h5>Zwroty</h5>

<li><a href="#1">Przyimki w zwrotach i wyrażeniach przysłówkowych i spójnikowych</a></li>
<li><a href="#2">Najważniejsze przymiotniki łączące się z przyimkami</a></li>

<a name="1"></a><h5>Przyimki w zwrotach i wyrażeniach przysłówkowych i spójnikowych</h5>
<table>
<tr><td width="20%">A caballo</td><td>konno</td></tr>
<tr><td>A cambio</td><td>w zamian za</td></tr>
<tr><td>A cántaros</td><td>jak z cebra, ulewnie</td></tr>
<tr><td>A carcajadas</td><td>głośno, na całe gardło</td></tr>
<tr><td>A caso hecho</td><td>celowo, specjalnie</td></tr>
<tr><td>A causa de</td><td>z powodu</td></tr>
<tr><td>A ciegas</td><td>na ślepo</td></tr>
<tr><td>A condición de (que)</td><td>pod warunkiem, że</td></tr>
<tr><td>A cosa de</td><td>około, mniej więcej</td></tr>
<tr><td>A chorros</td><td>strumieniami</td></tr>
<tr><td>A deshora</td><td>nie w porę</td></tr>
<tr><td>A despecho de</td><td>pomimo</td></tr>
<tr><td>A días</td><td>czasami, od czasu do czasu</td></tr>
<tr><td>A diferencia de</td><td>w przeciwieństwie do</td></tr>
<tr><td>A distancia</td><td>z daleka, z oddali</td></tr>
<tr><td>A empujones</td><td>popychając, gwałtownie</td></tr>
<tr><td>A escondidas</td><td>po kryjomu, ukradkiem</td></tr>
<tr><td>A falta de</td><td>z braku</td></tr>
<tr><td>A fin de cuentas</td><td>koniec końców, w końcu</td></tr>
<tr><td>A fuego lento</td><td>na wolnym ogniu</td></tr>
<tr><td>A horcajadas</td><td>okrakiem</td></tr>
<tr><td>A hurtadillas</td><td>ukradkiem</td></tr>
<tr><td>A la hora</td><td>w porę, punktualnie</td></tr>
<tr><td>A la larga</td><td>na dłuższą metę</td></tr>
<tr><td>A la par</td><td>równocześnie, razem, zarazem</td></tr>
<tr><td>A lo lejos</td><td>w oddali</td></tr>
<tr><td>A lo mejor</td><td>może, prawdopodobnie; możliwe, że</td></tr>
<tr><td>A lo menos</td><td>przynajmniej</td></tr>
<tr><td>A medias</td><td>połowicznie</td></tr>
<tr><td>A menos que</td><td>chyba żeby</td></tr>
<tr><td>A mi entender</td><td>według mnie, moim zdaniem</td></tr>
<tr><td>A mi parecer</td><td>moim zdaniem</td></tr>
<tr><td>A oscuras</td><td>po ciemku</td></tr>
<tr><td>A pedazos</td><td>na kawałki</td></tr>
<tr><td>A pie</td><td>pieszo, na piechotę</td></tr>
<tr><td>A plazos</td><td>na raty</td></tr>
<tr><td>A propósito</td><td>przy sposobności, odnośnie do, w związku z</td></tr>
<tr><td>A razón de</td><td>w stosunku do; (o cenie) po, za</td></tr>
<tr><td>A sabiendas</td><td>świadomie, umyślnie</td></tr>
<tr><td>A solas</td><td>sam na sam</td></tr>
<tr><td>A tiempo</td><td>na czas</td></tr>
<tr><td>A todo correr</td><td>całym pędem</td></tr>
<tr><td>A trechos</td><td>w odstępach, z przerwami</td></tr>
<tr><td>A última hora</td><td>w ostatniej chwili</td></tr>
<tr><td>A voluntad</td><td>do woli</td></tr>
<tr><td>Al aire libre</td><td>pod gołym niebem</td></tr>
<tr><td>Al contado</td><td>gotówką</td></tr>
<tr><td>Al fin (final)</td><td>w końcu</td></tr>
<tr><td>Al pie de la letra</td><td>dosłownie</td></tr>
<tr><td>Al revés</td><td>na odwrót, odwrotnie</td></tr>
<tr><td>Al vuelo</td><td>w lot</td></tr>
<tr><td>Con claridad</td><td>jasno, wyraźnie</td></tr>
<tr><td>Con creces</td><td>z naddatkiem</td></tr>
<tr><td>Con miras a</td><td>z zamiarem, w celu</td></tr>
<tr><td>Con motivo de</td><td>zokazji</td></tr>
<tr><td>Con perdón</td><td>za przeproszeniem</td></tr>
<tr><td>Con propiedad</td><td>właściwie</td></tr>
<tr><td>Con relación a</td><td>odnośnie do, jeśli chodzi o</td></tr>
<tr><td>Con respecto a</td><td>w związku z</td></tr>
<tr><td>Con rumbo a</td><td>w kierunku</td></tr>
<tr><td>Con sequedad</td><td>sucho</td></tr>
<tr><td>Con tal (de) que</td><td>pod warunkiem że, chyba żeby</td></tr>
<tr><td>Con tiempo</td><td>z czasem</td></tr>
<tr><td>Con tiento</td><td>ostrożnie, rozważnie</td></tr>
<tr><td>Con vista(s) a</td><td>mając na widoku</td></tr>
<tr><td>De acuerdo con</td><td>zgodnie z</td></tr>
<tr><td>De acuerdo</td><td>zgoda</td></tr>
<tr><td>De antemano</td><td>zawczasu</td></tr>
<tr><td>De balde</td><td>darmo, bezpłatnie</td></tr>
<tr><td>De buen tono</td><td>w dobrym tonie</td></tr>
<tr><td>De buena gana</td><td>chętnie</td></tr>
<tr><td>De buenas a primeras</td><td>od razu, nagle, znienacka</td></tr>
<tr><td>De burla</td><td>żartem</td></tr>
<tr><td>De cabo a rabo</td><td>od początku do końca</td></tr>
<tr><td>De camino</td><td>po drodze</td></tr>
<tr><td>De continuo</td><td>ciągle, nieustannie</td></tr>
<tr><td>De corazón</td><td>z serca</td></tr>
<tr><td>De corrido</td><td>płynnie</td></tr>
<tr><td>De costumbre</td><td>zwyczajowo, zwykle, zazwyczaj</td></tr>
<tr><td>De espanto</td><td>okropny, straszny</td></tr>
<tr><td>De golpe</td><td>nagle, raptem</td></tr>
<tr><td>De hecho</td><td>faktycznie, istotnie</td></tr>
<tr><td>De improviso</td><td>niespodziewanie</td></tr>
<tr><td>De la misma manera</td><td>tak samo, w ten sam sposób</td></tr>
<tr><td>De mala gana</td><td>niechętnie</td></tr>
<tr><td>De manera que</td><td>tak, że</td></tr>
<tr><td>De marca</td><td>markowy, wysokiej klasy</td></tr>
<tr><td>De más</td><td>za dużo</td></tr>
<tr><td>De memoria</td><td>na pamięć</td></tr>
<tr><td>De milagro</td><td>cudem</td></tr>
<tr><td>De momento</td><td>chwilowo</td></tr>
<tr><td>De muerte</td><td>śmiertelnie</td></tr>
<tr><td>De nuevo</td><td>znowu, na nowo, od nowa</td></tr>
<tr><td>De oídas</td><td>ze słyszenia</td></tr>
<tr><td>De ordinario</td><td>zwykle, zazwyczaj</td></tr>
<tr><td>De par en par</td><td>na oścież</td></tr>
<tr><td>De parte de</td><td>ze strony</td></tr>
<tr><td>De paso</td><td>po drodze</td></tr>
<tr><td>De por sí</td><td>sam z siebie</td></tr>
<tr><td>De por vida</td><td>na całe życie, dożywotnio</td></tr>
<tr><td>De primera</td><td>pierwszej jakości</td></tr>
<tr><td>De prisa</td><td>szybko, w pośpiechu</td></tr>
<tr><td>De pronto</td><td>nagle, znienacka, ni stąd ni zowąd</td></tr>
<tr><td>De puntillas</td><td>na palcach</td></tr>
<tr><td>De raíz</td><td>z korzeniami</td></tr>
<tr><td>De regreso</td><td>w drodze powrotnej</td></tr>
<tr><td>De repente</td><td>nagle</td></tr>
<tr><td>De reserva</td><td>w rezerwie</td></tr>
<tr><td>De rodillas</td><td>na kolanach</td></tr>
<tr><td>De seguro</td><td>z pewnością</td></tr>
<tr><td>De sobra</td><td>w nadmiarze</td></tr>
<tr><td>De todas maneras</td><td>w każdym razie</td></tr>
<tr><td>De todos modos</td><td>w każdym razie</td></tr>
<tr><td>De un tirón</td><td>od razu</td></tr>
<tr><td>Desde luego</td><td>oczywiście</td></tr>
<tr><td>En absoluto</td><td>w każdym razie, absolutnie nie</td></tr>
<tr><td>En adelante</td><td>na przyszłość, w przyszłości</td></tr>
<tr><td>En apariencia</td><td>pozornie</td></tr>
<tr><td>En alto</td><td>głośno</td></tr>
<tr><td>En atención a</td><td>z uwagi na</td></tr>
<tr><td>En balde</td><td>na próżno</td></tr>
<tr><td>En combio</td><td>za to</td></tr>
<tr><td>En común</td><td>wspólnie</td></tr>
<tr><td>En concepto de</td><td>z tytułu</td></tr>
<tr><td>En conformidad con</td><td>zgodnie z</td></tr>
<tr><td>En contra de</td><td>w przeciwieństwie do</td></tr>
<tr><td>En cuanto</td><td>kiedy, gdy tylko</td></tr>
<tr><td>En cuanto a</td><td>jeśli chodzi o, co do</td></tr>
<tr><td>En definitiva</td><td>w końcu, w efekcie, w rezultacie</td></tr>
<tr><td>En el acto</td><td>na miejscu</td></tr>
<tr><td>En eso</td><td>wtedy</td></tr>
<tr><td>En esto</td><td>właśnie wtedy</td></tr>
<tr><td>En general</td><td>na ogół, w ogóle</td></tr>
<tr><td>En lo sucesivo</td><td>następnie, w przyszłości</td></tr>
<tr><td>En lugar de</td><td>zamiast</td></tr>
<tr><td>En medio de</td><td>wśród</td></tr>
<tr><td>En parte</td><td>częściowo</td></tr>
<tr><td>En persona</td><td>osobiście, we własnej osobie</td></tr>
<tr><td>En principio</td><td>w zasadzie</td></tr>
<tr><td>En punto</td><td>dokładnie (o godzinie)</td></tr>
<tr><td>En redondo</td><td>jasno, wyraźnie, stanowczo</td></tr>
<tr><td>En regla</td><td>w porządku</td></tr>
<tr><td>En rigor</td><td>ściśle biorąc, w istocie rzeczy</td></tr>
<tr><td>En seco</td><td>na sucho; gwałtownie</td></tr>
<tr><td>En seguida</td><td>zaraz, natychmiast</td></tr>
<tr><td>En su día</td><td>w przyszłości</td></tr>
<tr><td>En su tanto</td><td>proporcjonalnie</td></tr>
<tr><td>En torno a</td><td>wokół</td></tr>
<tr><td>En vano</td><td>na próżno</td></tr>
<tr><td>En vez de</td><td>zamiast</td></tr>
<tr><td>En vista de</td><td>w związku z, mając na uwadze</td></tr>
<tr><td>En tanto</td><td>dopóki</td></tr>
<tr><td>Entre tanto</td><td>w tym czasie</td></tr>
<tr><td>Hasta ahora</td><td>do tej pory, dotąd</td></tr>
<tr><td>Hasta el tope</td><td>po brzegi, do pełna</td></tr>
<tr><td>Para siempre (jamás)</td><td>na zawsze</td></tr>
<tr><td>Sin embargo</td><td>jednak, mimo to</td></tr>
<tr><td>Sin falta</td><td>niechybnie, na pewno</td></tr>
<tr><td>Sin igual</td><td>niezrównany</td></tr>
<tr><td>Sin más ni menos</td><td>bez powodu; ni stąd ni zowąd</td></tr>
<tr><td>Sin proponérmelo</td><td>niechcący</td></tr>
<tr><td>Sin querer</td><td>niechcący</td></tr>
<tr><td>Sin rebozo</td><td>bez ogródek</td></tr>
<tr><td>Sin ton ni son</td><td>bez sensu</td></tr>
<tr><td>So pretexto</td><td>pod pretekstem</td></tr>
<tr><td>So pena de</td><td>pod groźbą, pod karą</td></tr>
<tr><td>Sobre la marcha</td><td>w drodze, po drodze</td></tr>
<tr><td>Sobre todo</td><td>przede wszystkim</td></tr>
</table>

<a name="2"></a><h5>Najważniejsze przymiotniki łączące się z przyimkami</h5>
<table width="50%">
<tr><td width="20%">A caballo</td><td>konno</td></tr>
<tr><td>Accesible a (para)</td><td>dostępny dla</td></tr>
<tr><td>Análogo</td><td>analogiczny względem</td></tr>
<tr><td>Apto para</td><td>zdatny do</td></tr>
<tr><td>Bueno de (para)</td><td>dobry do</td></tr>
<tr><td>Bueno con</td><td>dobry dla</td></tr>
<tr><td>Bueno para</td><td>dobry na</td></tr>
<tr><td>Cercano a</td><td>bliski (czego)</td></tr>
<tr><td>Coetáneo de</td><td>współczesny (czemu)</td></tr>
<tr><td>Común a (de, para, en)</td><td>wspólny (czemu)</td></tr>
<tr><td>Constante en (para)</td><td>stały w</td></tr>
<tr><td>Contiguo a</td><td>przyległy do</td></tr>
<tr><td>Desleal a (con, para, para con)</td><td>nielojalny wobec</td></tr>
<tr><td>Devoto de</td><td>przywiązany do, oddany (czemu)</td></tr>
<tr><td>Difícil de (para)</td><td>trudny do</td></tr>
<tr><td>Fácil de (para)</td><td>łatwy do</td></tr>
<tr><td>Hábil a (en, para, con)</td><td>zręczny do</td></tr>
<tr><td>Incansable en (para)</td><td>niezmordowany w</td></tr>
<tr><td>Incapaz de</td><td>niezdolny do</td></tr>
<tr><td>Independiente de</td><td>niezależny od</td></tr>
<tr><td>Insensible a</td><td>nieczuły na</td></tr>
<tr><td>Loco de</td><td>oszalały z</td></tr>
<tr><td>Loco por (con)</td><td>oszalały na punkcie</td></tr>
<tr><td>Orgulloso de (por)</td><td>dumny z</td></tr>
<tr><td>Posterior a</td><td>późniejszy niż</td></tr>
<tr><td>Propio a (de, para)</td><td>właściwy (czemu), typowy dla</td></tr>
<tr><td>Semejante a</td><td>podobny do</td></tr>
<tr><td>Sensible a</td><td>wrażliwy na</td></tr>
<tr><td>Sordo a</td><td>głuchy na</td></tr>
<tr><td>Superior a</td><td>wyższy niż</td></tr>
<tr><td>Útil a (para)</td><td>potrzebny do</td></tr>
</table>
    </SPhrase>
  )
};

export default Phrase;